import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import searchFetcher from "@/common/fetchSearchServices";
export var api__getRecommendedPosts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(userId) {
    var _res$data;
    var limit,
      params,
      res,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          limit = _args.length > 1 && _args[1] !== undefined ? _args[1] : 20;
          params = {
            user_id: userId,
            limit: limit
          };
          _context.n = 1;
          return searchFetcher().get("/search/recommended", {
            params: params
          });
        case 1:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
      }
    }, _callee);
  }));
  return function api__getRecommendedPosts(_x) {
    return _ref.apply(this, arguments);
  };
}();